import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../../../config';
import "../../../Styles/Admin/assessment/AssessmentLogin.css";

export default function AssessmentResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!newPassword || !confirmPassword) {
      setMessage("Please fill in both fields");
      setMessageType("error");
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage("Passwords do not match");
      setMessageType("error");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const res = await axios.post(`${API_BASE_URL}/api/assessment/auth/reset-password`, {
        token,
        password: newPassword,
      });

      setMessage(res.data.message || "Password updated successfully! Redirecting to login...");
      setMessageType("success");
      setTimeout(() => {
        navigate('/admin/assessment/login');
      }, 2000);
    } catch (err) {
      setMessage(err.response?.data?.message || "Something went wrong. Please try again.");
      setMessageType("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="assessment_adminlogin-container">
      <div className="assessment_adminlogin-left">
        <img
          src="/New_osw_logo.png"
          alt="Outstanding Workplaces Logo"
          className="assessment_adminlogin-logo-img"
        />
        <div className="assessment_adminlogin-illustration">
          <img src="/Customerlogin_img.png" alt="Reset Illustration" />
        </div>
        <div className="assessment_adminlogin-left-bottom">
          <h2>Reset Password</h2>
          <p>Set a new password for your account</p>
        </div>
      </div>

      <div className="assessment_adminlogin-right">
        <div className="assessment_adminlogin-form">
          <h2 className="assessment_adminform-heading">Reset Your Password</h2>
          <p className="assessment_adminform-subheading">
            Enter a new password for your account
          </p>

          <form onSubmit={handleSubmit}>
            <label className="assessment_adminform-label">New Password</label>
            <div className="assessment_adminpassword-field">
              <input
                type={showPassword ? "text" : "password"}
                className="assessment_adminform-input"
                placeholder="Enter new password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
              <img
                src="/Admin_log_eye.png"
                alt="toggle password visibility"
                className="assessment_adminpassword-eye-icon"
                onClick={() => setShowPassword(!showPassword)}
              />
            </div>

            <label className="assessment_adminform-label">Confirm Password</label>
            <div className="assessment_adminpassword-field">
              <input
                type={showPassword ? "text" : "password"}
                className="assessment_adminform-input"
                placeholder="Confirm new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </div>

            {message && (
              <p style={{
                color: messageType === "success" ? "#16a34a" : "#dc2626",
                fontSize: "14px",
                marginBottom: "12px",
                textAlign: "center"
              }}>
                {message}
              </p>
            )}

            <button
              type="submit"
              className="assessment_adminprimary-btn"
              disabled={loading}
              style={{ opacity: loading ? 0.7 : 1 }}
            >
              {loading ? "Updating..." : "Reset Password"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}